import { useLocation } from 'react-router-dom';
import { PrivateRoutes } from '../../routes/private.routes';
import { MODULOS_SIDEBAR, MODULOS_SO_DRILL } from './modulos';
import { moduloDaTelaAvulsa } from './submodulos';

/**
 * Módulo em drill da tela atual (menu lateral com os submódulos), via a flag
 * `hasDrillSidebar` de private.routes. O menu lateral e o cabeçalho (que nesse
 * modo mostra os módulos do sistema) usam a MESMA regra.
 *
 * A rota MAIS ESPECÍFICA vence: Emissão de NFS-e tem drill próprio dentro do
 * Fiscal (/modulesHome/supervisor/nfse-emissao). Telas do Fiscal/Integração que
 * moram fora do caminho do módulo (/modulesHome/fiscal/*) caem no módulo dono.
 */
export const useModuloDrill = () => {
  const { pathname } = useLocation();
  const avulsa = moduloDaTelaAvulsa(pathname);
  const drillRoute = PrivateRoutes.filter(
    r =>
      r.hasDrillSidebar &&
      (pathname === r.path || pathname.startsWith(`${r.path}/`) || r.path === avulsa),
  ).sort((a, b) => b.path.length - a.path.length)[0];
  const drillModule = drillRoute
    ? [...MODULOS_SIDEBAR, ...MODULOS_SO_DRILL].find(m => m.path === drillRoute.path)
    : undefined;
  return { isDrillMode: !!drillRoute, drillRoute, drillModule };
};
